export const testKnowConstants={
    ADD_TEST_REQUEST:"ADD_TEST_KNOW_REQUEST",
    ADD_TEST_SUCCESS:"ADD_TEST_KNOW_SUCCESS",
    ADD_TEST_FAILURE:"ADD_TEST_KNOW_FAILURE",

    AFFECT_TEST_REQUEST:"AFFECT_TEST_KNOW_REQUEST",
    AFFECT_TEST_SUCCESS:"AFFECT_TEST_KNOW_SUCCESS",
    AFFECT_TEST_FAILURE:"AFFECT_TEST_KNOW_FAILURE",
}